import apiClient from './client';

export interface AppNotification {
  id: number;
  type: string;
  title: string;
  body?: string;
  link?: string;
  is_read: boolean;
  created_at: string;
}

export const getNotifications = async (): Promise<AppNotification[]> => {
  const { data } = await apiClient.get('/notifications');
  return data.data;
};

export const getUnreadCount = async (): Promise<number> => {
  const { data } = await apiClient.get('/notifications/unread-count');
  return data.data.count;
};

export const markRead = async (id: number): Promise<void> => {
  await apiClient.put(`/notifications/${id}/read`);
};

export const markAllRead = async (): Promise<void> => {
  await apiClient.put('/notifications/read-all');
};

export const deleteNotification = async (id: number): Promise<void> => {
  await apiClient.delete(`/notifications/${id}`);
};
